<template>
  <li
    class="pr-6 py-4 hover:bg-gray-50 flex items-start"
    :class="[pipelineStage.type !== 'custom' && 'filter']"
  >
    <div class="flex-shrink-0 px-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        stroke-width="2"
        stroke="currentColor"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="w-5 h-5 handle cursor-move text-gray-400 hover:text-black"
        v-if="pipelineStage.type === 'custom'"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <circle cx="9" cy="5" r="1" />
        <circle cx="9" cy="12" r="1" />
        <circle cx="9" cy="19" r="1" />
        <circle cx="15" cy="5" r="1" />
        <circle cx="15" cy="12" r="1" />
        <circle cx="15" cy="19" r="1" />
      </svg>
    </div>
    <div class="flex-1" :class="[pipelineStage.type !== 'custom' && 'ml-5']">
      <div class="flex items-start">
        <div class="w-8 h-8 rounded-full flex-shrink-0" :style="{ backgroundColor: color }" />
        <div class="px-4">
          <p class="text-sm font-medium text-gray-900">
            {{ pipelineStage.name }}
          </p>
          <p class="text-sm text-gray-500">
            {{ pipelineStage.description || 'no description provided' }}
          </p>
        </div>
      </div>
    </div>
    <div class="flex-shrink-0">
      <PipelineStageActions
        :can-delete="pipelineStage.type === 'custom'"
        @edit="setShowEdit(true)"
        @change-color="setShowChangeColor(true)"
        @remove="remove"
      />
      <PipelineStageEditModal
        v-if="showEdit"
        :pipeline-stage="pipelineStage"
        @update="update"
        @close="setShowEdit(false)"
      />
      <PipelineStageChangeColorModal
        v-if="showChangeColor"
        :pipeline-stage="pipelineStage"
        @update="update"
        @close="setShowChangeColor(false)"
      />
    </div>
  </li>
</template>

<script>
import PipelineStageActions from './PipelineStageActions.vue';
import PipelineStageEditModal from './PipelineStageEditModal.vue';
import PipelineStageChangeColorModal from './PipelineStageChangeColorModal.vue';
import colors from './colors';

const components = {
  PipelineStageActions,
  PipelineStageEditModal,
  PipelineStageChangeColorModal,
};

const props = {
  pipelineStage: {
    type: Object,
    required: true,
  },
};

function data() {
  return {
    defaultColor: colors[0],
    showEdit: false,
    showChangeColor: false,
  };
}

const computed = {
  color() {
    return this.pipelineStage.color || this.defaultColor;
  },
};

const methods = {
  setShowEdit(value) {
    this.showEdit = Boolean(value);
  },
  setShowChangeColor(value) {
    this.showChangeColor = Boolean(value);
  },
  update(pipelineStageData) {
    this.$emit('update', pipelineStageData);
    this.setShowEdit(false);
    this.setShowChangeColor(false);
  },
  remove() {
    if (this.pipelineStage.type !== 'custom') {
      return;
    }
    this.$emit('remove');
  },
};

export default {
  components,
  props,
  data,
  computed,
  methods,
};
</script>
